export default {
  hour: 'Час',
  minute: 'Мин',
};
